import { isValidUrl } from '../../misc';

const isIframeValid = code => {
  const tempCode = document.createElement('div');
  tempCode.innerHTML = code;
  const src = tempCode.querySelector('iframe').getAttribute('src');

  return isValidUrl(src);
};

export default isIframeValid;
